import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {ReloadOutlined} from '@ant-design/icons';
import {useQuery} from '@apollo/client';
import {Button, Spin} from 'antd';
import _ from 'lodash';

import labels from '../../../config/labels.json';
import {ILabel} from '../../../config/lebels-type';
import {MULTI_FORM} from '../../../config/routes';
import {widgets, widgetsVariables} from '../../../shared/graphql/__generated__/widgets';
import {QUERY_WIDGETS} from '../../../shared/graphql/widget';
import {Card} from '../Card';

import {IWidget} from './type';

import cls from '../Index.module.scss'

export const Widget = ({identifier}: IWidget) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    // загружаем данные виджета
    // ищем последние данные
    const widgets = useQuery<widgets,widgetsVariables>(QUERY_WIDGETS, {
        variables: {
            filters: {
                identifier: {eq: identifier},
            },
            sort: ['createdAt:DESC'],
            pagination: {
                limit: 1
            }
        }
    })

    if (widgets.loading) {
        return (
            <Card title={''}>
                <Spin/>
            </Card>
        )
    }

    const result = widgets.data?.widgets ? widgets.data?.widgets[0] : null;

    const item = _.filter(labels, (label:ILabel) => label.identifier === identifier)[0]
    const welcome = item.welcome

    const text = !result ? <span className={cls.welcome}>{welcome}</span> : t(result.message!)
    const value = result?.value ? (Math.floor(result?.value! * 10) / 10).toString() : undefined;

    return (
        <Card title={t(item.label)} icon={item.icon} result={value}>
            <div>{text}</div>
            {!result && <Button type={'primary'} onClick={() => navigate(MULTI_FORM, {state: {identifier: identifier}})}>Заполнить данные</Button>}
            {result && <Button type={'link'} onClick={() => navigate(MULTI_FORM, {state: {identifier: identifier}})} icon={<ReloadOutlined/>}>Обновить</Button>}
        </Card>
    )

}